import React from 'react';
import axios from '../axios';
// import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';
import { GenerateOutlineModal } from './generate_outline_modal';
// import Category from './category';
// import TagsInput from './tags_input';

const SectionSubject = ({
  event,
  setEvent,
  bodyText,
  setBodyText,
  // categoryError,
  // setCategoryError,
  // servicesCategories,
  bodyError,
  titleError,
  setTitleError,
  updateTextContent,
  onFocusScrollForAndroid,
  userAgent,
}) => {
  const modalRef = React.useRef(null);
  const [lastUpdateTime, setLastUpdateTime] = React.useState(0);

  // イベント説明を20秒以上間隔をおいてDBに自動保存
  const updateTextContentToDB = (text) => {
    const currentTime = Date.now();
    if (currentTime - lastUpdateTime >= 20000) {
      updateTextContent && updateTextContent(text);
      setLastUpdateTime(currentTime);
    } else {
      return;
    }
  };

  const generateDefaultImage = React.useCallback(() => {
    const body = JSON.stringify({
      event_id: event.id,
      event_title: event.title,
    });
    axios.post('/api/event/generate_default_image', body).then((response) => {
      setEvent((prev) => ({
        ...prev,
        main_image_url_medium_strict: response.data.main_image_url,
      }));
    });
  }, [event]);

  const onBlurTitle = React.useCallback(() => {
    //画像がない場合、デフォルト画像を自動生成
    if (
      event.main_image_url_medium_strict == undefined &&
      !!event.title &&
      15 <= event.title.length &&
      event.title.length <= 100
    ) {
      generateDefaultImage();
    }
  }, [event]);

  // const onCategoryError = React.useCallback(() => {
  //   if (!event.category_id) {
  //     setCategoryError('カテゴリーを1つ選択してください。');
  //   } else {
  //     setCategoryError('');
  //   }
  // }, [event]);

  const onTitleError = React.useCallback(() => {
    if (!event.title || event.title.length < 15 || event.title.length > 100) {
      setTitleError('タイトルは15文字以上100文字以内で入力してください。');
    } else {
      setTitleError('');
    }
  }, [event]);

  return (
    <section id="event_details">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          イベント内容
        </p>
      </div>
      <div className="shadow-sm mb-0 bg-white">
        {/* <div
          className={`container col-md-8 col-lg-6 p-3_5 border-bottom ${
            !!categoryError && 'bg-light-pink'
          }`}
        >
          <ModalContentBaseXl
            ref={modalRef}
            previewContent={
              <div>
                {categoryError && (
                  <p className="text-danger text-fz-small mt-0 mb-0">
                    {categoryError}
                  </p>
                )}
                <div className="row">
                  <p className="col-5 text-fz-16px text-black-444 text-fw-normal mt-2 mb-0 pl-2">
                    カテゴリー
                  </p>
                  <p className="col-6 nav-link link--arrow text-fz-16px text-gray text-fw-normal mb-0 mr-2 text-right">
                    {event.category_id
                      ? servicesCategories
                          .map((service) =>
                            service.categories.find(
                              (category) => category.id == event.category_id
                            )
                          )
                          .find((e) => e != undefined).name
                      : '必須'}
                  </p>
                </div>
              </div>
            }
            modalContent={
              <Category
                event={event}
                closeModal={() => {
                  modalRef.current.closeModal();
                }}
                servicesCategories={servicesCategories}
                onChangeCategory={(e) =>
                  setEvent((prev) => ({ ...prev, category_id: e.target.value }))
                }
              />
            }
          />
        </div> */}
        {/* <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row">
            <p className="col-2 text-fz-16px text-black-444 text-fw-normal mt-2 mb-0 pl-2">
              タグ
            </p>
            <p className="col-8 text-fz-16px text-gray text-fw-normal mt-2 mb-0">
              最大20個まで登録できます
            </p>
          </div>
          <TagsInput
            event={event}
            setEvent={setEvent}
          />
          <div>
            <p className="text-gray text-fz-small mt-1 mb-0">
              改行またはEnter Keyで登録を保存できます。
            </p>
          </div>
        </div> */}
        <div className="container col-md-8 col-lg-6">
          <div className="row justify-content-between align-items-center">
            <p className="col-5 text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
              イベント名
              <span className="text-fz-14px text-fw-bold text-gray mb-2 mt-1 ml-2 d-inline-block">
                必須
              </span>
            </p>
            <div className="col-5 d-flex justify-content-end align-items-center">
              <GenerateOutlineModal
                onAcceptEventTitle={(newEventTitle) => {
                  setEvent((prev) => ({ ...prev, title: newEventTitle }));
                  onBlurTitle();
                }}
                onAcceptEventBody={(newEventBody) => {
                  setBodyText(newEventBody);
                  updateTextContent && updateTextContent(newEventBody);
                }}
              />
            </div>
          </div>
          {titleError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{titleError}</p>
          )}
          <input
            id="title"
            className={`p-1 w-100 form-control ${
              titleError ? 'border border-danger' : ''
            }`}
            onBlur={() => onBlurTitle()}
            onClick={() => onCategoryError()}
            value={event.title || ''}
            onChange={(e) =>
              setEvent((prev) => ({ ...prev, title: e.target.value }))
            }
            placeholder="たのしいハロウィンパーティーイベント"
            onFocus={(e) => onFocusScrollForAndroid(e)}
            rows="3"
          />
        </div>
        <div className="container col-md-8 col-lg-6 px-3 py-3">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-1 d-inline-block">
            イベントの説明
            <span className="text-fz-14px text-fw-bold text-gray mb-2 mt-1 ml-2 d-inline-block">
              必須
            </span>
          </p>
          {bodyError && (
            <p className="text-danger text-fz-small mt-0 mb-0">{bodyError}</p>
          )}
          <textarea
            id="body"
            className={`p-1 w-100 form-control ${
              bodyError ? 'border border-danger' : ''
            }`}
            onBlur={() => {
              updateTextContentToDB(bodyText);
            }}
            onClick={() => onTitleError()}
            placeholder={
              'イベントの概要、楽しめる点、注意点など\n例）みんなでハロウィーンパーティしましょう！仮装できる人はぜひ仮装してきてください！\n渋谷駅近くのレンタルスペースで行います！\n基本的にみんな一人参加なので、お気軽に参加してくださいね！\n\n●当日の流れ\n18:00 待ち合わせ場所に集合\n18:10 班分けしてみんなで買い出し\n19:00 パーティ開始\n21:00 解散\n\n●持ち物\n仮装するための衣装（する人だけでOK）\n\n●注意事項\n勧誘などはNGです。'
            }
            value={bodyText}
            onChange={(e) => {
              setBodyText(e.target.value);
              updateTextContentToDB(e.target.value);
            }}
            onFocus={(e) => onFocusScrollForAndroid(e)}
            rows={userAgent === 'android' ? '8' : '12'}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionSubject;
